import React from "react";
import { ReactComponent as Icon } from "./../../assets/icons/share.svg";
import * as S from "./CardDetail.style";

function CardDetail({ title, link }) {
  return (
    <>
      <S.Container>
        <S.PStyled>{title}</S.PStyled>
        <S.Line></S.Line>
        <S.Buttons>
          <S.Link href={link} target="_blank" rel="noopener noreferrer">
            Acessar
          </S.Link>
          <Icon />
        </S.Buttons>
      </S.Container>
    </>
  );
}

export default CardDetail;
